var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBilling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.5,7.7V3c0-0.5-0.4-1-1-1h-13c-0.5,0-1,0.4-1,1v13v5c0,0.5,0.4,1,1,1h13.1c0.5,0,1-0.4,1-1v-2v-3.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.5,
    y1: 7.9,
    x2: 13.5,
    y2: 7.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.5,
    y1: 7.9,
    x2: 16.5,
    y2: 7.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.5,
    y1: 10.3,
    x2: 13.5,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.5,
    y1: 10.3,
    x2: 16.5,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.5,
    y1: 12.7,
    x2: 13.5,
    y2: 12.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.5,
    y1: 15.1,
    x2: 13.5,
    y2: 15.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.5,
    y1: 12.7,
    x2: 16.5,
    y2: 12.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.5,
    y1: 15.1,
    x2: 16.5,
    y2: 15.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "polygon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    d: "M20.9,12.2c0-0.1-0.1-0.2-0.2-0.3L20,11.5l-0.5-0.3l-0.7-0.4c-0.1-0.1-0.2-0.2-0.2-0.3V9.8 c0-0.1,0.1-0.2,0.2-0.3l0.6-0.3c0.1-0.1,0.2-0.1,0.3,0l0.6,0.3c0.1,0.1,0.2,0.2,0.2,0.3v0.7c0,0.1-0.1,0.2-0.2,0.3L19.9,11 l0.5,0.3l0.4-0.2c0.1-0.1,0.2-0.2,0.2-0.3V9.6c0-0.1-0.1-0.2-0.2-0.3l-1.1-0.6c-0.1-0.1-0.2-0.1-0.3,0l-1.1,0.6 c-0.1,0.1-0.2,0.2-0.2,0.3v1.2c0,0.1,0.1,0.2,0.2,0.3l0.7,0.4l0.5,0.3l0.7,0.4c0.1,0.1,0.2,0.2,0.2,0.3v0.7 c0,0.1-0.1,0.2-0.2,0.3l-0.6,0.3c-0.1,0.1-0.2,0.1-0.3,0l-0.6-0.3c-0.1-0.1-0.2-0.2-0.2-0.3v-0.7c0-0.1,0.1-0.2,0.2-0.3l0.4-0.2 l-0.5-0.3l-0.4,0.2C18.1,12,18,12.1,18,12.2v1.2c0,0.1,0.1,0.2,0.2,0.3l1.1,0.6c0.1,0.1,0.2,0.1,0.3,0l1.1-0.6 c0.1-0.1,0.2-0.2,0.2-0.3L20.9,12.2z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBilling);
export default __webpack_public_path__ + "static/media/icon-billing.d6e46c29259f0965e442c9bedc7fd4ca.svg";
export { ForwardRef as ReactComponent };